import * as React from 'react';
import { useStoreActions } from 'easy-peasy';
import { useParams } from 'react-router-dom';
import { Get, Post } from '../services/http';
import { validateForm } from '../services/validate';

export default function ThankYouPage() {
    const [currency, setCurrency] = React.useState(null);
    const [donationSum, setDonationSum] = React.useState(null);
    const openInfoPopup = useStoreActions((actions) => actions.open);
    const { transactionType, transactionID } = useParams();
    const [donation, setDonationData] = React.useState(null);

    const [thankYouMode, setThankYouMode] = React.useState('donation');

    const getDonationData = async () => {
        const donationServer = await Get('/api/donation/GetDonation', { id: transactionID });
        console.log('donationServer', donationServer);
        const donationData = donationServer.donation;
        /*  if (donationData.name !== '' && donationData.name != null) {
             const splitName = donationData.name?.split(' ');
             const firstName = splitName[0];
             const lastName = splitName.length > 1 ? splitName[1] : '';
         } */
        setDonationData(donationData);
        setCurrency(donationData.currency);
        const tipGeneral = donationData.tipGeneralSum !== null ? parseFloat(donationData.tipGeneralSum) : 0;
        const tipCommision = donationData.tipPercentSum !== null ? parseFloat(donationData.tipPercentSum) : 0;
        const total = parseFloat(donationData.sum) + tipGeneral + tipCommision;
        setDonationSum(total);
    };

    React.useEffect(() => {
        switch (transactionType) {
            case ('donation'):
                getDonationData();
                setThankYouMode('donation');
                break;
            case ('subscriber-form'):
                setThankYouMode('subscribe');
                break;
            default:
                return;
        }
    }, [transactionType]);

    return (
        <main class="main">
            <div class="main__body">
                <div class="container">
                    <div class="login-page">

                        {thankYouMode === 'donation' ? (
                            <>
                                <h1 class="login-page__title">
                                    <span>Your donation has been successfully received</span>
                                </h1>
                                <h2 class="form-section__label">Your Donation: {donation?.campaignName}</h2>                               
                                <h3>
                                    Subtotal: {currency}{donationSum?.toFixed(2)}
                                </h3>
                                <h3>
                                    Total: {currency}{donationSum?.toFixed(2)}
                                </h3>
                                Thank you for your donation
                            </>
                        ) : ''}
                        {thankYouMode === 'subscribe' ? ( // sign up form   
                            <>
                                <h1 class="login-page__title">
                                    <span>Thank you!</span>
                                </h1>
                                <h2 class="form-section__label">Thank you!</h2>
                                <h3>
                                Your application has been processed. You will be notified by email upon approval of your account.
                                </h3>
                            </>
                        ) : ''}
                    </div>
                </div>
            </div>
        </main>
    );
}
